import { Dialog } from "@mui/material";
import { DeleteOutlineOutlined } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { getUserInfo } from "../../../../../../services/authService";
import { fetchGraphMethod } from "../../../../../../services/httpService";
import messagePopup from "../../../../../../utils/messagePopup";
import {
  allStatsfieldbasedonpositionsQuery,
  getAllUserStatsFieldsQuery,
  saveSessionStatQuery,
  saveAllStatsQuery
} from "./statsQuery";
import swal from "sweetalert";
import TrashRedIcon from "../assets/img/trash-red-icon.svg";
import warningMessagePopup from "../../../../../../utils/warningMagPop";
import toastr from 'toastr';


const AddEditBtn = (props) => {
  return (
    <div className="graph-edit-button">
      <a className="edit-button" onClick={props.onEdit}>
        <span className="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16.414"
            height="16.347"
            viewBox="0 0 16.414 16.347"
          >
            <path
              className="a"
              d="M15.992,2.65,13.838.495a1.59,1.59,0,0,0-2.244.091A1.592,1.592,0,0,0,11.5,2.831l2.155,2.155A1.591,1.591,0,0,0,15.9,4.895a1.591,1.591,0,0,0,.089-2.245ZM2.257,9.921,6.566,14.23l7-7L9.259,2.919l-7,7ZM0,16.421l5.684-1.138L1.138,10.737Z"
              transform="translate(0 -0.074)"
            ></path>
          </svg>
        </span>
        <span>Edit</span>
      </a>
      <button
        className="edit-button"
        data-toggle="modal"
        data-target="#EnterSeasonOneStatsModal"
        onClick={props.onAddSeason}
      >
        <span className="icon plus">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
          >
            <g transform="translate(1.553 1.553)">
              <line className="a" x2="15" transform="translate(-0.053 7.447)" />
              <line className="a" y2="15" transform="translate(7.447 -0.053)" />
            </g>
          </svg>
        </span>
        <span>Add Season</span>
      </button>
    </div>
  );
};

const SaveCancelBtn = (props) => {
  return (
    <div className="graph-edit-button">
      <button className="btn green" onClick={props.onSave}>
        Save Data
      </button>
      <a
        className="btn"
        onClick={(e) => {
          props.onCancel(e, props.id);
        }}
      >
        Cancel
      </a>
    </div>
  );
};

const AddSeasonModal = (props) => {
  const [teamDetails, SetTeamDetails] = useState();
  const [positionDetails, SetPositionDetails] = useState();
  const todayDate = new Date().toISOString().split("T")[0];
  const [fields, setFields] = useState({
    seasonstartdate: todayDate,
    seasonenddate: todayDate,
  });
  const [error, setError] = useState({
    seasonstartdate: "",
    seasonenddate: "",
  });
  const [twoYearsAfterStartDate, setTwoYearsAfterStartDate] = useState();
  useEffect(() => {
    if (props.team && props.team.length) {
      SetTeamDetails(props.team[0]);
    }
  }, [props.team]);
  useEffect(() => {
    if (props.position && props.position.length) {
      SetPositionDetails(props.position[0]);
    }
  }, [props.positions]);
  useEffect(() => {
    const date = new Date(fields.seasonstartdate);
    let year = date.getFullYear();
    let month = date.getMonth();
    month = month + 1;
    if (month < 10) {
      month = "0" + month;
    }
    let day = date.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    year = year + 2;
    const FullDate = year + '-' + month + '-' + day;
    setTwoYearsAfterStartDate(FullDate);
  }, [fields.seasonstartdate, fields.seasonenddate])
  const onChangeHandler = (e, field) => {
    setError({});
    const fieldT = fields;
    fieldT[field] = e.target.value;
    setFields({ ...fieldT });
    setError({ seasonstartdate: "", seasonenddate: "" });
  };
  const handleValidation = () => {
    let isValid = true;
    if (!fields.seasonstartdate) {
      isValid = false;
      setError((prev) => {
        return { ...prev, seasonstartdate: "Please choose a start Date" };
      });
    }
    if (!fields.seasonenddate) {
      isValid = false;
      setError((prev) => {
        return { ...prev, seasonenddate: "Please choose a end Date" };
      });
    }
    if (fields.seasonstartdate && fields.seasonenddate) {
      if (fields.seasonstartdate > fields.seasonenddate) {
        isValid = false;
        setError((prev) => {
          return {
            ...prev,
            seasonenddate: "End date should be greater than or equal to Start date",
          };
        });
      }
      if (fields.seasonenddate > twoYearsAfterStartDate) {
        isValid = false;
        setError((prev) => {
          return {
            ...prev,
            seasonenddate: "A Season can't be of more than 2 years",
          };
        });
      }
    }
    return isValid;
  };
  const onSaveStateHandler = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      props.onSave(fields.seasonstartdate, fields.seasonenddate, props.id);
    }
  };
  return (
    <div
      className="modal fade common-modal form-modal stats-modal show"
      id="EnterSeasonOneStatsModal"
      style={{ display: "block", paddingRight: "9px" }}
      aria-modal="true"
      role="dialog"
    >   
      <div
        className="modal-dialog modal-dialog-centered editprofile-common-form"
        role="document"
      >
        <form className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add a Season</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.onClose}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="fieldBox flexBox">
              <div className="half">
                <label>Team</label>
                <p className="text-uppercase text-left">
                  <strong>{teamDetails && teamDetails.teamname}</strong>
                </p>
              </div>
              <div className="half">
                <label>Position</label>
                <p className="text-uppercase text-left">
                  <strong>
                    {positionDetails && positionDetails.shortform}
                  </strong>
                </p>
              </div>
            </div>
            <div className="fieldBox">
              <label>Season Start Date <sup>*</sup></label>
              <input
                type="date"
                value={fields.seasonstartdate}
                placeholder="07/10/2020"
                onChange={(e) => {
                  onChangeHandler(e, "seasonstartdate");
                }}
                max="9999-12-31"
              />
              {error.seasonstartdate ? (
                <div className="error">{error.seasonstartdate}</div>
              ) : (
                ""
              )}
            </div>
            <div className="fieldBox mb-0">
              <label>Season End Date <sup>*</sup></label>
              <input
                type="date"
                value={fields.seasonenddate}
                placeholder="07/10/2020"
                onChange={(e) => {
                  onChangeHandler(e, "seasonenddate");
                }}
                max="9999-12-31"
              />
              {error.seasonenddate ? (
                <div className="error">{error.seasonenddate}</div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="modal-footer">
            <a className="btn green" onClick={onSaveStateHandler}>
              Next
            </a>
            <button
              type="button"
              className="btn"
              data-dismiss="modal"
              onClick={props.onClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const SeasonsList = (props) => {
  const [editEnable, setEditEnable] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [fieldList, setFieldList] = useState([]);
  const [fieldingFieldName, setFieldingFieldName] = useState([]);
  const [hittingfieldname, setHittingfieldname] = useState([]);
  const [catchingfieldname, setCatchingfieldname] = useState([]);
  const [pitchingfieldname, setPitchingfieldname] = useState([]);
  const [showAddSeasonModal, setShowAddSeasonModal] = useState(false);
  const [allSesstion, setaAllSesstion] = useState([]);
  const [savedId, setSavedId] = useState(0);
  useEffect(() => {
    fetchStats();
  }, [props.season]);
  useEffect(() => {
    setSavedId(props.savedId);
  }, [props.savedId]);
  useEffect(() => {
    setEditEnable(props.isEdit);
  }, [props.isEdit]);
  useEffect(() => {
    fetchUserStats();
  }, [
    fieldingFieldName,
    hittingfieldname,
    catchingfieldname,
    pitchingfieldname,
  ]);
  const fetchStats = async () => {
    const variables = {
      where: {
        positionid: props.season.positionid,
      },
    };
    const res = await fetchGraphMethod(
      allStatsfieldbasedonpositionsQuery,
      variables,
      true
    );
    if (
      res &&
      res.data &&
      res.data.data &&
      res.data.data.allStatsfieldbasedonpositions &&
      res.data.data.allStatsfieldbasedonpositions.Statsfieldbasedonpositions &&
      res.data.data.allStatsfieldbasedonpositions.Statsfieldbasedonpositions
        .length
    ) {
      const data =
        res.data.data.allStatsfieldbasedonpositions
          .Statsfieldbasedonpositions[0];
      if (data.fieldingfieldname) {
        setFieldingFieldName(JSON.parse(data.fieldingfieldname));
      } else {
        setFieldingFieldName([]);
      }
      if (data.hittingfieldname) {
        setHittingfieldname(JSON.parse(data.hittingfieldname));
      } else {
        setHittingfieldname([]);
      }
      if (data.catchingfieldname) {
        setCatchingfieldname(JSON.parse(data.catchingfieldname));
      } else {
        setCatchingfieldname([]);
      }
      if (data.pitchingfieldname) {
        setPitchingfieldname(JSON.parse(data.pitchingfieldname));
      } else {
        setPitchingfieldname([]);
      }
    }
  };
  const fetchUserStats = async () => {
    const variables = {
      where: {
        statid: props.id,
        userid: getUserInfo().id,
        active: 1,
      },
    };
    const pitchingData = await pitchingfieldname.map((item) => {
      return item.dbCloName;
    });
    const fieldingData = await fieldingFieldName.map((item) => {
      return item.dbCloName;
    });
    const catchingData = await catchingfieldname.map((item) => {
      return item.dbCloName;
    });
    const hittingData = await hittingfieldname.map((item) => {
      return item.dbCloName;
    });
    const query = await getAllUserStatsFieldsQuery([
      ...pitchingData,
      ...fieldingData,
      ...catchingData,
      ...hittingData,
    ]);
    const res = await fetchGraphMethod(query, variables, true);
    let fieldsT = [];
    if (
      res.data &&
      res.data.data &&
      res.data.data.allSeassionstats &&
      res.data.data.allSeassionstats.Seassionstats &&
      res.data.data.allSeassionstats.Seassionstats.length
    ) {
      setaAllSesstion(res.data.data.allSeassionstats.Seassionstats)
      const fieldsArray = res.data.data.allSeassionstats.Seassionstats.map(
        (item, index) => {
          fieldsT.push({});
          for (const key in item) {
            if (item.hasOwnProperty(key)) {
              fieldsT[index] = { ...fieldsT[index], [key]: item[key] };
            }
          }
        }
      );
    } else {
      const pitchingData = pitchingfieldname.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]: 0,
        };
      }, {});
      const fieldingData = fieldingFieldName.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]: 0,
        };
      }, {});
      const catchingData = catchingfieldname.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]: 0,
        };
      }, {});
      const hittingData = hittingfieldname.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]: 0,
        };
      }, {});

      fieldsT = [
        {
          ...pitchingData,
          ...fieldingData,
          ...catchingData,
          ...hittingData,
        },
      ];
    }
    setFieldList([...fieldsT]);
  };

  const createSeason = (seasonstartdate, seasonenddate) => {
    const data = fieldList.filter((item) => {
      if (
        item.seasonstartdate == seasonstartdate &&
        item.seasonenddate == seasonenddate
      ) {
        return item;
      }
    });
    if (data.length) {
      // messagePopup("", "Record already exists", "warning");
      toastr.warning("Record already exists", "", {
        progressBar: true, timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
      return;
    }
    if (fieldList.length != 20) {
      let fieldsT = [];
      const pitchingData = pitchingfieldname.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]: 0,
        };
      }, {});
      const fieldingData = fieldingFieldName.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]: 0,
        };
      }, {});
      const catchingData = catchingfieldname.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]: 0,
        };
      }, {});
      const hittingData = hittingfieldname.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]: 0,
        };
      }, {});


      fieldsT = [
        {
          statid: props.id,
          userid: getUserInfo().id,
          active: 1,
          seasonstartdate,
          seasonenddate,
          ...pitchingData,
          ...fieldingData,
          ...catchingData,
          ...hittingData,
        },
      ];
      setIsAdded(true);
      setFieldList([...fieldList, ...fieldsT]);
      setEditEnable(true);
      setShowAddSeasonModal(false);
    } else {
      // messagePopup("", "Seasons Limit Reached", "warning");
      toastr.warning("Seasons Limit Reached", "", {
        progressBar: true, timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
    }
  };

  const createOtherSeason = async (seasonstartdate, seasonenddate, statId) => {
    const data = fieldList.filter((item) => {
      if (
        item.seasonstartdate == seasonstartdate &&
        item.seasonenddate == seasonenddate
      ) {
        return item;
      }
    });
    if (data.length) {
      // messagePopup("", "Record already exists", "warning");
      toastr.warning("Record already exists", "", {
        progressBar: true, timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
      return;
    }
    if (fieldList.length != 20) {
      const variables = {
        obj: {
          seasonstartdate: seasonstartdate,
          seasonenddate: seasonenddate,
          userid: getUserInfo().id,
          statid: statId,
          active: 1
        },
      };
      const res = await fetchGraphMethod(
        saveSessionStatQuery,
        variables,
        true
      );
      setShowAddSeasonModal(false);
      fetchUserStats()
      window.location.reload();
      // messagePopup("", "Seasons saved successfully.", "success");
      toastr.success("Seasons saved successfully.", "", {
        progressBar: true, timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
    } else {
      // messagePopup("", "Seasons Limit Reached", "warning");
      toastr.warning("Seasons Limit Reached", "", {
        progressBar: true, timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
    }
  };

  const editHandler = (e, change = false) => {
    if (change) {
      props.onCancel(e, props.id, true);
    }
    setEditEnable(!editEnable);
  };
  const addSeasonHandler = (e) => {
    e.preventDefault();
    setShowAddSeasonModal(!showAddSeasonModal);
  };
  const onChangeHandler = (e, field, minVal, maxVal, index) => {
    e.preventDefault();
    let value =
      parseFloat(e.target.value) >= minVal && parseFloat(e.target.value) <= maxVal
        ? parseFloat(e.target.value)
        : ""
    const fieldsT = fieldList[index];
    if (field == "gamestarted") {
      if (!fieldsT["gameplayed"] || fieldsT["gameplayed"] < value) {
        messagePopup(
          "",
          "GS (Game Started) should be less than or equal to  GP (Game played)",
          "warning"
        );
        value = "null"
        //return;
      }
    }
    if (field == "gameplayed") {
      if (isNaN(value) || fieldsT["gamestarted"] > value) {
        messagePopup(
          "",
          "GP (Game Played) should be more than or equal to GS (Game Started).",
          "warning"
        );
        value = "null"
        //return;
      }
      if (fieldsT["losses"]) {
        if (parseFloat(value) < parseFloat(fieldsT["losses"])) {
          messagePopup(
            "",
            "GP (Game played) should be more than or equal L (Losses) ",
            "warning"
          );
          value = "null"
          //return;
        }
      }
      if (parseFloat(value) < (parseFloat(fieldsT["losses"]) + parseFloat(fieldsT["wins"]))) {
        messagePopup(
          "",
          "GP (Game played) should be more than or equal L (Losses) + W (Wins) ",
          "warning"
        );
        value = "null"
        //return;
      }
    }
    if (field == "losses") {
      if (!fieldsT["gameplayed"] || fieldsT["gameplayed"] < value) {
        messagePopup(
          "",
          "L (Losses) should be less than GP (Game played)",
          "warning"
        );
        value = "null"
        //return;
      }
      if (
        fieldsT["gameplayed"] - fieldsT["wins"] < value) {
        messagePopup(
          "",
          "L (Losses) + W (Wins) can't be greater than GP (Game played)",
          "warning"
        );
        value = "null"
        //return;
      }
    }
    if (field == "wins") {
      if (fieldsT["gameplayed"] < value) {
        messagePopup(
          "",
          "W (Wins) should be less than equal to GP (Game played)",
          "warning"
        );
        value = "null"
        //return;
      }
      if (
        fieldsT["gameplayed"] - fieldsT["losses"] < value
      ) {
        messagePopup(
          "",
          "L (Losses) + W (Wins) can't be greater than GP (Game played)",
          "warning"
        );
        value = "null"
        //return;
      }
    }
    if (field == "savedata") {
      const savedataValue = isNaN(value) ? 0 : value
      fieldsT["saveopportunities"] = savedataValue + (fieldsT["blownsaves"] ? fieldsT["blownsaves"] : 0);
      if (savedataValue) {
        fieldsT["savepercentage"] =
          ((savedataValue / (savedataValue + (fieldsT["blownsaves"] ? fieldsT["blownsaves"] : 0))) * 100).toFixed(1);
      } else {
        fieldsT["savepercentage"] = 0
      }
    }
    //blownsaves
    if (field == "blownsaves") {
      const bsValue = isNaN(value) ? 0 : value
      fieldsT["saveopportunities"] = bsValue + (fieldsT["savedata"] ? fieldsT["savedata"] : 0);
      fieldsT["savepercentage"] =
        ((fieldsT["savedata"] / (bsValue + (fieldsT["savedata"] ? fieldsT["savedata"] : 0))) * 100).toFixed(1);
    }

    if (field == "saveopportunities") {
      const soValue = isNaN(value) ? 0 : value
      if (fieldsT["savedata"] || soValue) {
        fieldsT["savepercentage"] = fieldsT["savedata"] / soValue;
      }
    }
    if (field == "atbat") {
      const atValue = isNaN(value) ? 0 : value
      if (fieldsT["hits"] && atValue != undefined) {
        fieldsT["avg"] = atValue == 0 ? .000 : (fieldsT["hits"] / atValue).toFixed(3);
      }
      if (fieldsT["hita"] && atValue) {
        fieldsT["average"] = atValue == 0 ? .000 : (fieldsT["hita"] / atValue).toFixed(3);
      }
      if (fieldsT["hita"]) {
        fieldsT["onbasepercentage"] =
          ((fieldsT["hits"] + fieldsT["basesonballs"] + fieldsT["hitbattersa"]) /
            (atValue +
              fieldsT["basesonballs"] +
              fieldsT["hitbattersa"] +
              fieldsT["sacrificefile"])).toFixed(3);
        fieldsT["onbaseplusslugging"] =
          (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
        if (fieldsT["inningspitched"] && fieldsT["hits"] && fieldsT["walkbasedonballs"]) {
          fieldsT["walksandhitsperinningpitched"] =
            ((fieldsT["hita"] + fieldsT["walkbasedonballs"]) / fieldsT["inningspitched"]).toFixed(3);
        }
      } else {
        fieldsT["onbasepercentage"] =
          ((fieldsT["hits"] + fieldsT["basesonballs"] + fieldsT["hitbattersa"]) /
            (atValue +
              fieldsT["basesonballs"] +
              fieldsT["hitbattersa"] +
              fieldsT["sacrificefile"])).toFixed(3);
        fieldsT["onbaseplusslugging"] =
          (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
      }
      fieldsT["sluggingpercentage"] =
        ((1 * (fieldsT["firstbaseman"] != undefined && fieldsT["firstbaseman"] != "" ? fieldsT["firstbaseman"] : 0) +
          2 * (fieldsT["secondbaseman"] != undefined && fieldsT["secondbaseman"] != "" ? fieldsT["secondbaseman"] : 0) +
          3 * (fieldsT["thirdbaseman"] != undefined && fieldsT["thirdbaseman"] != "" ? fieldsT["thirdbaseman"] : 0) +
          4 * (fieldsT["homerunsa"] != undefined && fieldsT["homerunsa"] != "" ? fieldsT["homerunsa"] : 0)) /
          atValue).toFixed(3);
      fieldsT["onbaseplusslugging"] =
        (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
    }
    //
    if (field == "hits") {
      const hvalue = isNaN(value) ? 0 : value
      if (fieldsT["atbat"] && hvalue != undefined) {
        fieldsT["avg"] = hvalue == 0 ? .000 : (hvalue / fieldsT["atbat"]).toFixed(3);
      }
      if (fieldsT["inningspitched"] && hvalue && fieldsT["walkbasedonballs"]) {
        fieldsT["walksandhitsperinningpitched"] =
          ((hvalue + fieldsT["walkbasedonballs"]) / fieldsT["inningspitched"]).toFixed(3);
      }
      fieldsT["onbasepercentage"] =
        ((hvalue + fieldsT["basesonballs"] + fieldsT["hitbattersa"]) /
          (fieldsT["basesonballs"] +
            fieldsT["atbat"] +
            fieldsT["hitbattersa"] +
            fieldsT["sacrificefile"])).toFixed(3);
      fieldsT["onbaseplusslugging"] =
        (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
    }
    if (field == "hita") {
      const haValue = isNaN(value) ? 0 : value
      if (fieldsT["atbat"] && haValue) {
        fieldsT["average"] = haValue / fieldsT["atbat"];
      }
      fieldsT["onbasepercentage"] =
        ((haValue + fieldsT["basesonballs"] + fieldsT["hitbattersa"]) /
          (fieldsT["basesonballs"] +
            fieldsT["atbat"] +
            fieldsT["hitbattersa"] +
            fieldsT["sacrificefile"])).toFixed(3);
      fieldsT["onbaseplusslugging"] =
        (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
    }

    if (field == "basesonballs") {
      const baseValue = isNaN(value) ? 0 : value
      if (fieldsT["hita"]) {
        fieldsT["onbasepercentage"] =
          ((baseValue + fieldsT["hits"] + fieldsT["hitbattersa"]) /
            (baseValue +
              fieldsT["atbat"] +
              fieldsT["hitbattersa"] +
              fieldsT["sacrificefile"])).toFixed(3);
        fieldsT["onbaseplusslugging"] =
          (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
      } else {
        fieldsT["onbasepercentage"] =
          ((fieldsT["hitbattersa"] + fieldsT["hits"] + baseValue) /
            (baseValue + fieldsT["atbat"] + fieldsT["sacrificefile"] + fieldsT["hitbattersa"])).toFixed(3);
        fieldsT["onbaseplusslugging"] =
          (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
      }

    }
    if (field == "hitbattersa") {
      const hbsValue = isNaN(value) ? 0 : value
      if (fieldsT["hita"]) {
        fieldsT["onbasepercentage"] =
          ((fieldsT["hits"] + fieldsT["basesonballs"] + hbsValue) /
            (fieldsT["basesonballs"] + fieldsT["atbat"] + hbsValue + fieldsT["sacrificefile"])).toFixed(3);
        fieldsT["onbaseplusslugging"] =
          (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
      } else {
        fieldsT["onbasepercentage"] =
          ((fieldsT["hits"] + fieldsT["basesonballs"] + hbsValue) /
            (fieldsT["basesonballs"] + fieldsT["atbat"] + fieldsT["sacrificefile"] + hbsValue)).toFixed(3);
        fieldsT["onbaseplusslugging"] =
          (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
      }
    }
    if (field == "sacrificefile") {
      const sfValue = isNaN(value) ? 0 : value
      if (fieldsT["hita"]) {
        fieldsT["onbasepercentage"] =
          ((fieldsT["hitbattersa"] + fieldsT["hits"] + fieldsT["basesonballs"]) /
            (fieldsT["basesonballs"] + fieldsT["atbat"] + sfValue + fieldsT["hitbattersa"])).toFixed(3);
        fieldsT["onbaseplusslugging"] =
          (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
      } else {
        fieldsT["onbasepercentage"] =
          ((fieldsT["hitbattersa"] + fieldsT["hits"] + fieldsT["basesonballs"]) /
            (fieldsT["basesonballs"] + fieldsT["atbat"] + sfValue + fieldsT["hitbattersa"])).toFixed(3);
        fieldsT["onbaseplusslugging"] =
          (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
      }

    }

    if (field == "firstbaseman") {
      const fbValue = isNaN(value) ? 0 : (value == "" ? 0 : value)
      fieldsT["sluggingpercentage"] = fieldsT["atbat"] == 0 ? 0 :
        ((1 * fbValue +
          2 * (fieldsT["secondbaseman"] != undefined && fieldsT["secondbaseman"] != "" ? fieldsT["secondbaseman"] : 0) +
          3 * (fieldsT["thirdbaseman"] != undefined && fieldsT["thirdbaseman"] != "" ? fieldsT["thirdbaseman"] : 0) +
          4 * (fieldsT["homerunsa"] != undefined && fieldsT["homerunsa"] != "" ? fieldsT["homerunsa"] : 0)) /
          (fieldsT["atbat"] != undefined ? fieldsT["atbat"] : 0)).toFixed(3);
      fieldsT["onbaseplusslugging"] =
        (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
      fieldsT["hits"] = fbValue + (fieldsT["secondbaseman"] != undefined && fieldsT["secondbaseman"] != "" ? fieldsT["secondbaseman"] : 0) + (fieldsT["thirdbaseman"] != undefined && fieldsT["thirdbaseman"] != "" ? fieldsT["thirdbaseman"] : 0) + (fieldsT["homerunsa"] != undefined && fieldsT["homerunsa"] != "" ? fieldsT["homerunsa"] : 0);
      const totalVal = fbValue + (fieldsT["secondbaseman"] != undefined && fieldsT["secondbaseman"] != "" ? fieldsT["secondbaseman"] : 0) + (fieldsT["thirdbaseman"] != undefined && fieldsT["thirdbaseman"] != "" ? fieldsT["thirdbaseman"] : 0) + (fieldsT["homerunsa"] != undefined && fieldsT["homerunsa"] != "" ? fieldsT["homerunsa"] : 0)
      fieldsT["avg"] = fieldsT["atbat"] == 0 ? .000 : (totalVal / fieldsT["atbat"]).toFixed(3);
      if (fieldsT["inningspitched"] && totalVal && fieldsT["walkbasedonballs"]) {
        fieldsT["walksandhitsperinningpitched"] =
          ((totalVal + fieldsT["walkbasedonballs"]) / fieldsT["inningspitched"]).toFixed(3);
      }
      //
      fieldsT["onbasepercentage"] =
        ((totalVal + fieldsT["basesonballs"] + fieldsT["hitbattersa"]) /
          (fieldsT["basesonballs"] +
            fieldsT["atbat"] +
            fieldsT["hitbattersa"] +
            fieldsT["sacrificefile"])).toFixed(3);
      fieldsT["onbaseplusslugging"] =
        (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
    }
    if (field == "secondbaseman") {
      const sbValue = isNaN(value) ? 0 : (value == "" ? 0 : value)
      fieldsT["sluggingpercentage"] = fieldsT["atbat"] == 0 ? 0 :
        ((1 * (fieldsT["firstbaseman"] != undefined && fieldsT["firstbaseman"] != "" ? fieldsT["firstbaseman"] : 0) +
          2 * sbValue +
          3 * (fieldsT["thirdbaseman"] != undefined && fieldsT["thirdbaseman"] != "" ? fieldsT["thirdbaseman"] : 0) +
          4 * (fieldsT["homerunsa"] != undefined && fieldsT["homerunsa"] != "" ? fieldsT["homerunsa"] : 0)
        ) /
          (fieldsT["atbat"] != undefined ? fieldsT["atbat"] : 0)).toFixed(3);
      fieldsT["onbaseplusslugging"] =
        (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
      fieldsT["hits"] = (fieldsT["firstbaseman"] != undefined && fieldsT["firstbaseman"] != "" ? fieldsT["firstbaseman"] : 0) + sbValue + (fieldsT["thirdbaseman"] != undefined && fieldsT["thirdbaseman"] != "" ? fieldsT["thirdbaseman"] : 0) + (fieldsT["homerunsa"] != undefined && fieldsT["homerunsa"] != "" ? fieldsT["homerunsa"] : 0)
      const totalValS = (fieldsT["firstbaseman"] != undefined && fieldsT["firstbaseman"] != "" ? fieldsT["firstbaseman"] : 0) + sbValue + (fieldsT["thirdbaseman"] != undefined && fieldsT["thirdbaseman"] != "" ? fieldsT["thirdbaseman"] : 0) + (fieldsT["homerunsa"] != undefined && fieldsT["homerunsa"] != "" ? fieldsT["homerunsa"] : 0)
      fieldsT["avg"] = fieldsT["atbat"] == 0 ? .000 : (totalValS / fieldsT["atbat"]).toFixed(3);
      if (fieldsT["inningspitched"] && totalValS && fieldsT["walkbasedonballs"]) {
        fieldsT["walksandhitsperinningpitched"] =
          ((totalValS + fieldsT["walkbasedonballs"]) / fieldsT["inningspitched"]).toFixed(3);
      }
      //
      fieldsT["onbasepercentage"] =
        ((totalValS + fieldsT["basesonballs"] + fieldsT["hitbattersa"]) /
          (fieldsT["basesonballs"] +
            fieldsT["atbat"] +
            fieldsT["hitbattersa"] +
            fieldsT["sacrificefile"])).toFixed(3);
      fieldsT["onbaseplusslugging"] =
        (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
    }
    if (field == "thirdbaseman") {
      const thbValue = isNaN(value) ? 0 : (value == "" ? 0 : value)
      fieldsT["sluggingpercentage"] = fieldsT["atbat"] == 0 ? 0 :
        ((1 * (fieldsT["firstbaseman"] != undefined && fieldsT["firstbaseman"] != "" ? fieldsT["firstbaseman"] : 0) +
          2 * (fieldsT["secondbaseman"] != undefined && fieldsT["secondbaseman"] != "" ? fieldsT["secondbaseman"] : 0) +
          4 * (fieldsT["homerunsa"] != undefined && fieldsT["homerunsa"] != "" ? fieldsT["homerunsa"] : 0) +
          3 * thbValue) /
          (fieldsT["atbat"] != undefined ? fieldsT["atbat"] : 0)).toFixed(3);
      fieldsT["onbaseplusslugging"] =
        (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
      fieldsT["hits"] = (fieldsT["firstbaseman"] != undefined && fieldsT["firstbaseman"] != "" ? fieldsT["firstbaseman"] : 0) + (fieldsT["secondbaseman"] != undefined && fieldsT["secondbaseman"] != "" ? fieldsT["secondbaseman"] : 0) + thbValue + (fieldsT["homerunsa"] != undefined && fieldsT["homerunsa"] != "" ? fieldsT["homerunsa"] : 0)
      const totalValT = (fieldsT["firstbaseman"] != undefined && fieldsT["firstbaseman"] != "" ? fieldsT["firstbaseman"] : 0) + (fieldsT["secondbaseman"] != undefined && fieldsT["secondbaseman"] != "" ? fieldsT["secondbaseman"] : 0) + thbValue + (fieldsT["homerunsa"] != undefined && fieldsT["homerunsa"] != "" ? fieldsT["homerunsa"] : 0)
      fieldsT["avg"] = fieldsT["atbat"] == 0 ? .000 : (totalValT / fieldsT["atbat"]).toFixed(3);
      if (fieldsT["inningspitched"] && totalValT && fieldsT["walkbasedonballs"]) {
        fieldsT["walksandhitsperinningpitched"] =
          ((totalValT + fieldsT["walkbasedonballs"]) / fieldsT["inningspitched"]).toFixed(3);
      }
      //
      fieldsT["onbasepercentage"] =
        ((totalValT + fieldsT["basesonballs"] + fieldsT["hitbattersa"]) /
          (fieldsT["basesonballs"] +
            fieldsT["atbat"] +
            fieldsT["hitbattersa"] +
            fieldsT["sacrificefile"])).toFixed(3);
      fieldsT["onbaseplusslugging"] =
        (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
    }

    if (field == "homerunsa") {
      const homeValue = isNaN(value) ? 0 : (value == "" ? 0 : value)
      fieldsT["sluggingpercentage"] = fieldsT["atbat"] == 0 ? 0 :
        ((1 * (fieldsT["firstbaseman"] != undefined && fieldsT["firstbaseman"] != "" ? fieldsT["firstbaseman"] : 0) +
          2 * (fieldsT["secondbaseman"] != undefined && fieldsT["secondbaseman"] != "" ? fieldsT["secondbaseman"] : 0) +
          3 * (fieldsT["thirdbaseman"] != undefined && fieldsT["thirdbaseman"] != "" ? fieldsT["thirdbaseman"] : 0) +
          4 * homeValue) /
          (fieldsT["atbat"] != undefined ? fieldsT["atbat"] : 0)).toFixed(3);
      fieldsT["onbaseplusslugging"] =
        (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
      fieldsT["hits"] = (fieldsT["firstbaseman"] != undefined && fieldsT["firstbaseman"] != "" ? fieldsT["firstbaseman"] : 0) + (fieldsT["secondbaseman"] != undefined && fieldsT["secondbaseman"] != "" ? fieldsT["secondbaseman"] : 0) + (fieldsT["thirdbaseman"] != undefined && fieldsT["thirdbaseman"] != "" ? fieldsT["thirdbaseman"] : 0) + homeValue
      const totalValHR = (fieldsT["firstbaseman"] != undefined && fieldsT["firstbaseman"] != "" ? fieldsT["firstbaseman"] : 0) + (fieldsT["secondbaseman"] != undefined && fieldsT["secondbaseman"] != "" ? fieldsT["secondbaseman"] : 0) + (fieldsT["thirdbaseman"] != undefined && fieldsT["thirdbaseman"] != "" ? fieldsT["thirdbaseman"] : 0) + homeValue
      fieldsT["avg"] = fieldsT["atbat"] == 0 ? .000 : (totalValHR / fieldsT["atbat"]).toFixed(3);
      if (fieldsT["inningspitched"] && totalValHR && fieldsT["walkbasedonballs"]) {
        fieldsT["walksandhitsperinningpitched"] =
          ((totalValHR + fieldsT["walkbasedonballs"]) / fieldsT["inningspitched"]).toFixed(3);
      }
      fieldsT["onbasepercentage"] =
        ((totalValHR + fieldsT["basesonballs"] + fieldsT["hitbattersa"]) /
          (fieldsT["basesonballs"] +
            fieldsT["atbat"] +
            fieldsT["hitbattersa"] +
            fieldsT["sacrificefile"])).toFixed(3);
      fieldsT["onbaseplusslugging"] =
        (parseFloat(fieldsT["onbasepercentage"]) + parseFloat(fieldsT["sluggingpercentage"]));
    }
    if (field == "inningspitched") {
      // if (fieldsT["walkbasedonballs"] && value && fieldsT["hita"]) {
      const inValue = isNaN(value) ? 0 : value
      fieldsT["walksandhitsperinningpitched"] =
        ((fieldsT["walkbasedonballs"] + fieldsT["hita"]) / inValue).toFixed(3);
      //}
    }
    // code added 
    if (props.position[0].id == 1 || props.position[0].id == 2) {
      if (field == "inningspitched") {
        const innValue = isNaN(value) ? 0 : value
        fieldsT["earnedrunaverage"] =
          (7 * (fieldsT["earnedruns"] / innValue)).toFixed(2);
      }
      if (field == "earnedruns") {
        const earValue = isNaN(value) ? 0 : value
        if (fieldsT["inningspitched"]) {
          fieldsT["earnedrunaverage"] =
            (7 * (earValue / fieldsT["inningspitched"])).toFixed(2);
        } else {
          fieldsT["earnedrunaverage"] = 0.00
        }
      }
    }

    //
    if (field == "walkbasedonballs") {
      const walkValue = isNaN(value) ? 0 : value
      if (fieldsT["inningspitched"] && walkValue && fieldsT["hita"]) {
        fieldsT["walksandhitsperinningpitched"] =
          ((walkValue + fieldsT["hita"]) / fieldsT["inningspitched"]).toFixed(3);
      }
    }
    if (field == "putouts") {
      const pValue = isNaN(value) || !!value ? 0 : value
      if (fieldsT["assists"] || pValue || fieldsT["errorsvalue"]) {
        fieldsT["fieldingpercentage"] = parseFloat(
          (
            (pValue + fieldsT["assists"]) /
            (pValue + fieldsT["assists"] + fieldsT["errorsvalue"])
          ).toFixed(3)
        );
      }
    }
    if (field == "assists") {
      const aValue = isNaN(value) || value == "" ? 0 : value
      if (fieldsT["putouts"] || aValue || fieldsT["errorsvalue"]) {
        fieldsT["fieldingpercentage"] = parseFloat(
          (
            (aValue + fieldsT["putouts"]) /
            (aValue + fieldsT["putouts"] + fieldsT["errorsvalue"])
          ).toFixed(3)
        );
      }
    }
    if (field == "errorsvalue") {
      const eValue = isNaN(value) || value == "" ? 0 : value
      if (fieldsT["assists"] || eValue || fieldsT["putouts"]) {
        fieldsT["fieldingpercentage"] = parseFloat(
          (
            (fieldsT["putouts"] + fieldsT["assists"]) /
            (eValue + fieldsT["assists"] + fieldsT["putouts"])
          ).toFixed(3)
        );
      }
    }

    if (
      props.position[0].id == 1 ||
      props.position[0].id == 2 ||
      props.position[0].id == 3 ||
      props.position[0].id == 4 ||
      props.position[0].id == 7 ||
      props.position[0].id == 8 ||
      props.position[0].id == 9 ||
      props.position[0].id == 6 ||
      props.position[0].id == 5 ||
      props.position[0].id == 10 ||
      props.position[0].id == 11
    ) {
      if (field == "putouts") {
        const pvalue = isNaN(value) || value == "" ? 0 : value
        fieldsT["totalchances"] =
          pvalue + (fieldsT["assists"] != "" ? fieldsT["assists"] : 0) + (fieldsT["errorsvalue"] != "" ? fieldsT["errorsvalue"] : 0);
      }
      if (field == "assists") {
        const avalue = isNaN(value) || value == "" ? 0 : value
        fieldsT["totalchances"] =
          avalue + (fieldsT["putouts"] != "" ? fieldsT["putouts"] : 0) + (fieldsT["errorsvalue"] != "" ? fieldsT["errorsvalue"] : 0);
      }
      if (field == "errorsvalue") {
        const evalue = isNaN(value) || value == "" ? 0 : value
        fieldsT["totalchances"] =
          evalue + (fieldsT["assists"] != "" ? fieldsT["assists"] : 0) + (fieldsT["putouts"] != "" ? fieldsT["putouts"] : 0);
      }
    }
    if (props.position[0].id == 7) {
      if (field == "stolenbases") {
        const stoValue = isNaN(value) || value == "" ? 0 : value
        fieldsT["sba"] = stoValue + (fieldsT["caughtstealing"] != null && fieldsT["caughtstealing"] != undefined ? fieldsT["caughtstealing"] : 0);

        fieldsT["sbpct"] = (fieldsT["caughtstealing"] != null && fieldsT["caughtstealing"] != undefined ? fieldsT["caughtstealing"] : 0) / fieldsT["sba"];
      }
      if (field == "caughtstealing") {
        const caValue = isNaN(value) || value == "" ? 0 : value
        fieldsT["sba"] = caValue + fieldsT["stolenbases"];
        fieldsT["sbpct"] = caValue / fieldsT["sba"];
      }
    }

    //walksandhitsperinningpitched
    fieldsT[field] = isNaN(value) ? "" : value;
    const startArr = fieldList.slice(0, index);
    const endArr = fieldList.slice(index + 1);

    if (fieldList.length != 1) {
      if (startArr.length && endArr.length) {
        setFieldList([
          ...(startArr.length != 0 ? startArr : ""),
          { ...fieldsT },
          ...(endArr.length != 0 ? endArr : ""),
        ]);
      }
      if (!startArr.length) {
        setFieldList([{ ...fieldsT }, ...(endArr.length != 0 ? endArr : "")]);
      }
      if (!endArr.length) {
        setFieldList([
          ...(startArr.length != 0 ? startArr : ""),
          { ...fieldsT },
        ]);
      }
    } else {
      setFieldList([{ ...fieldsT }]);
    }
  };
  const onSaveHandler = async (e) => {
    for (var fieldSave of fieldList) {
      const pitchingData = await pitchingfieldname.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]: parseFloat(fieldSave[item.dbCloName])

        };
      }, {});
      const fieldingData = await fieldingFieldName.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]:
            parseFloat(fieldSave[item.dbCloName])
        };
      }, {});
      const catchingData = await catchingfieldname.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]:
            //  fieldSave[item.dbCloName] != "" && fieldSave[item.dbCloName] != "null" && fieldSave[item.dbCloName] != null
            // ? 
            parseFloat(fieldSave[item.dbCloName])
          // : null,
        };
      }, {});
      const hittingData = await hittingfieldname.reduce((acc, item, index) => {
        return {
          ...acc,
          [item.dbCloName]:
            //fieldSave[item.dbCloName] != "" && fieldSave[item.dbCloName] != "null" && fieldSave[item.dbCloName] != null
            //?
            parseFloat(fieldSave[item.dbCloName])
          //: null,
        };
      }, {});
      const variable = {
        obj: {
          id: fieldSave.id,
          statid: props.id,
          userid: getUserInfo().id,
          active: 1,
          seasonstartdate: fieldSave.seasonstartdate,
          seasonenddate: fieldSave.seasonenddate,
          //Pitching Fields
          ...pitchingData,
          ...fieldingData,
          ...catchingData,
          ...hittingData,
        },
      };
      props.onSaveFields(e, variable, true);
    }
    // });
    setEditEnable(false);
    setIsAdded(false);
    fetchUserStats();
    setSavedId(0);
  };

  const deleteSeasonFieldsStats = () => {
    swal({
      text: "Stats deleted successfully",
      icon: "success",
    }).then((okay) => {
      if (okay || okay == null) {
        window.location.reload();
      }
    });
  }

  const onDeleteHandler = (e, id, statid) => {
    e.preventDefault();
    const confirmation = warningMessagePopup("", "Are you sure you want to delete this entire season of stats?", "warning");
    confirmation.then(async (value) => {
      if (value == true) {
        // if (fieldList.length != 1) {
        if (id) {
          const variables = {
            obj: {
              id,
              userid: getUserInfo().id,
              active: 0,
            },
          };
          const res = await fetchGraphMethod(
            saveSessionStatQuery,
            variables,
            true
          )
          if (statid) {
            const statvariables = {
              obj: {
                id: statid,
                userid: getUserInfo().id,
                active: 0,
              },
            };
            const statres = await fetchGraphMethod(
              saveAllStatsQuery,
              statvariables,
              true
            )
            deleteSeasonFieldsStats()
          }
        } else {
          props.onCancel(e, props.id);
        }
      }
    });
    setIsAdded(false);
  };
  const getYears = (startYear, endYear) => {
    return startYear == endYear ? startYear : `${startYear}-${endYear}`;
  };
  const onCancelHandler = (e, id) => {
    if (editEnable) {
      if (savedId && fieldList.length != 1) {
        onDeleteHandler(e, fieldList[fieldList.length - 1].id, fieldList[fieldList.length - 1].statid);
      }
      if (savedId && fieldList.length == 1) {
        props.onCancel(e, id);
      }
      if (!savedId && isAdded) {
        props.onCancel(e, id);
      }
    }
    editHandler(e, true);
  };
  const valSeasonInput = (e, fieldName, idx) => {
    const validNumber = new RegExp(/^\d+$/);
    if (!!e?.target?.value) {
      const val = e?.target?.value,
        test = validNumber?.test(val)
      if (test) {
        return true
      } else {
        const fieldsT = fieldList[idx];
        fieldsT[fieldName] = ""
        setFieldList([{ ...fieldsT }]);
        return false
      }
    }
    else if (e?.target?.value == "") {
      const fieldsT = fieldList[idx];
      fieldsT[fieldName] = ""
      setFieldList([{ ...fieldsT }]);
      return true
    } else {
      const fieldsT = fieldList[idx];
      fieldsT[fieldName] = ""
      setFieldList([{ ...fieldsT }]);
      return false
    }
  }
  return (
    <div className="building-champions-chart">
      {fieldList.length != 0
        ? fieldList.map((field, idx) => {
          return (
            <div className="table-responsive">
              <table className="table table-bordered" key={idx}>
                <tbody>
                  <tr className="field-name">
                    <th></th>
                    <th></th>
                    {pitchingfieldname?.length > 0 ?
                      <th colSpan={pitchingfieldname.length}>Pitching</th>
                      : null}
                    {fieldingFieldName?.length > 0 ?
                      <th colSpan={fieldingFieldName.length}>Fielding</th>
                      : null}
                    {catchingfieldname?.length > 0 ?
                      <th colSpan={catchingfieldname.length}>Catching</th>
                      : null}
                    {hittingfieldname?.length > 0 ?
                      <th colSpan={hittingfieldname.length}>Hitting</th>
                      : null}
                  </tr>
                  <tr>
                    <td></td>
                    <td>SEASON</td>
                    {pitchingfieldname.map((item, index) => {
                      return <td key={`pfn_${index}`}>{item.colName}</td>;
                    })}
                    {fieldingFieldName.map((item, index) => {
                      return <td key={`ffn_${index}`}>{item.colName}</td>;
                    })}
                    {catchingfieldname.map((item, index) => {
                      return <td key={`cfn_${index}`}>{item.colName}</td>;
                    })}
                    {hittingfieldname.map((item, index) => {
                      return <td key={`hfn_${index}`}>{item.colName}</td>;
                    })}
                  </tr>
                  <tr>
                    <td key={`td_${idx}`}>
                      <img
                        src={TrashRedIcon}
                        alt="delete"
                        onClick={(e) => {
                          onDeleteHandler(e, field.id, field.statid);
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </td>
                    <td>
                      {getYears(
                        field?.seasonstartdate?.split("-")[0],
                        field?.seasonenddate?.split("-")[0]
                      )}
                    </td>
                    {pitchingfieldname.map((item, index) => {
                      return (
                        <td key={`pfn2_${index}`}>
                          <input
                            id={index}
                            placeholder={""}
                            value={
                              fieldList[idx][item.dbCloName] == undefined ?  fieldList[idx][item.dbCloName] : item.disabled == "true" && item.dbCloName!="totalchances" && item.dbCloName!="saveopportunities" ? ((fieldList[idx][item.dbCloName].toString().slice(0, 2) != "0." ? (fieldList[idx][item.dbCloName].toString().includes(".") == false ? (item.dbCloName=="earnedrunaverage" ? fieldList[idx][item.dbCloName].toString() + ".00" :(item.dbCloName=="savepercentage" ? fieldList[idx][item.dbCloName].toString() + ".0" :fieldList[idx][item.dbCloName].toString() + ".000")) :(fieldList[idx][item.dbCloName].toString().length == 2 ?(item.dbCloName=="savepercentage" ? fieldList[idx][item.dbCloName].toString() :(item.dbCloName=="earnedrunaverage" ? fieldList[idx][item.dbCloName].toString() + "00" :fieldList[idx][item.dbCloName].toString() + "000")):(fieldList[idx][item.dbCloName].toString().length==3?(item.dbCloName=="savepercentage" ? fieldList[idx][item.dbCloName].toString():(item.dbCloName=="earnedrunaverage"? fieldList[idx][item.dbCloName].toString() + "00" : fieldList[idx][item.dbCloName].toString() + "00")):(fieldList[idx][item.dbCloName].toString().length== 4 ? (item.dbCloName=="earnedrunaverage" ? fieldList[idx][item.dbCloName].toString() :(item.dbCloName=="savepercentage" ? fieldList[idx][item.dbCloName].toString()  :fieldList[idx][item.dbCloName].toString() + "0")):(fieldList[idx][item.dbCloName].toString()))))) : (fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 4 ? fieldList[idx][item.dbCloName].toString().replace("0.", ".") : (fieldList[idx][item.dbCloName].toString().replace("0.", ".")) + (fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 2 ? "00" :(fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 3 ? "0":fieldList[idx][item.dbCloName].toString().replace("0.", ".")))))) : (fieldList[idx][item.dbCloName].toString().replace("0.", "."))
                            }
                            min={item.minimum}
                            max={item.maximum}
                            onChange={(e) => valSeasonInput(e, item.dbCloName, idx) ? (
                              onChangeHandler(
                                e,
                                item.dbCloName,
                                item.minimum,
                                item.maximum,
                                idx
                              )
                            )
                              :
                              console.log("Invalid Input")
                            }
                            disabled={!editEnable || item.disabled == "true"}
                            type={
                              item.dataType == "numeric" ? "number" : "text"
                            }
                          />
                        </td>
                      );
                    })}
                    {fieldingFieldName.map((item, index) => {
                      return (
                        <td key={`ffn2_${index}`}>
                          <input
                            value={
                              fieldList[idx][item.dbCloName] == undefined ?  fieldList[idx][item.dbCloName] : item.disabled == "true" && item.dbCloName!="totalchances" ? ((fieldList[idx][item.dbCloName].toString().includes("0.") == false ? (fieldList[idx][item.dbCloName].toString().includes(".") == false ? (fieldList[idx][item.dbCloName].toString() + ".000") :(fieldList[idx][item.dbCloName].toString().length == 2 ?(fieldList[idx][item.dbCloName].toString() + "000"):(fieldList[idx][item.dbCloName].toString().length==3?(fieldList[idx][item.dbCloName].toString() + "00"):(fieldList[idx][item.dbCloName].toString().length== 4 ? (fieldList[idx][item.dbCloName].toString() + "0"):(fieldList[idx][item.dbCloName].toString()))))) : (fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 4 ? fieldList[idx][item.dbCloName].toString().replace("0.", ".") : (fieldList[idx][item.dbCloName].toString().replace("0.", ".")) + (fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 2 ? "00" :(fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 3 ? "0":fieldList[idx][item.dbCloName].toString().replace("0.", ".")))))) : (fieldList[idx][item.dbCloName].toString().replace("0.", "."))
                            }
                            onChange={(e) => valSeasonInput(e, item.dbCloName, idx) ? (
                              onChangeHandler(
                                e,
                                item.dbCloName,
                                item.minimum,
                                item.maximum,
                                idx
                              ))
                              :
                              console.log("invalid value")
                            }
                            disabled={!editEnable || item.disabled == "true"}
                            type={
                              item.dataType == "numeric" ? "number" : "text"
                            }
                          />
                        </td>
                      );
                    })}
                    {catchingfieldname.map((item, index) => {
                      return (
                        <td key={`cfn2_${index}`}>
                          <input
                            value={
                              fieldList[idx][item.dbCloName] == undefined ?  fieldList[idx][item.dbCloName] : item.disabled == "true" && item.dbCloName!="sba" && item.dbCloName!="totalchances" ? ((fieldList[idx][item.dbCloName].toString().includes("0.") == false ? (fieldList[idx][item.dbCloName].toString().includes(".") == false ? (fieldList[idx][item.dbCloName].toString() + ".000") :(fieldList[idx][item.dbCloName].toString().length == 2 ?(fieldList[idx][item.dbCloName].toString() + "000"):(fieldList[idx][item.dbCloName].toString().length==3?(fieldList[idx][item.dbCloName].toString() + "00"):(fieldList[idx][item.dbCloName].toString().length== 4 ? (fieldList[idx][item.dbCloName].toString() + "0"):(fieldList[idx][item.dbCloName].toString()))))) : (fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 4 ? fieldList[idx][item.dbCloName].toString().replace("0.", ".") : (fieldList[idx][item.dbCloName].toString().replace("0.", ".")) + (fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 2 ? "00" :(fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 3 ? "0":fieldList[idx][item.dbCloName].toString().replace("0.", ".")))))) : (fieldList[idx][item.dbCloName].toString().replace("0.", "."))
                            }
                            onChange={(e) => valSeasonInput(e, item.dbCloName, idx) ? (
                              onChangeHandler(
                                e,
                                item.dbCloName,
                                item.minimum,
                                item.maximum,
                                idx
                              ))
                              :
                              console.log("invalid value")
                            }
                            disabled={!editEnable || item.disabled == "true"}
                            type={
                              item.dataType == "numeric" ? "number" : "text"
                            }
                          />
                        </td>
                      );
                    })}
                    {hittingfieldname.map((item, index) => {
                      return (
                        <td key={`hfn2_${index}`}>
                          <input
                            value={
                              fieldList[idx][item.dbCloName] == undefined ?  fieldList[idx][item.dbCloName] : item.disabled == "true" && item.dbCloName != "hits" ? ((fieldList[idx][item.dbCloName].toString().includes("0.") == false ? (fieldList[idx][item.dbCloName].toString().includes(".") == false ? (fieldList[idx][item.dbCloName].toString() + ".000") :(fieldList[idx][item.dbCloName].toString().length == 2 ?(fieldList[idx][item.dbCloName].toString() + "000"):(fieldList[idx][item.dbCloName].toString().length==3?(fieldList[idx][item.dbCloName].toString() + "00"):(fieldList[idx][item.dbCloName].toString().length== 4 ? (fieldList[idx][item.dbCloName].toString() + "0"):(fieldList[idx][item.dbCloName].toString()))))) : (fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 4 ? fieldList[idx][item.dbCloName].toString().replace("0.", ".") : (fieldList[idx][item.dbCloName].toString().replace("0.", ".")) + (fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 2 ? "00" :(fieldList[idx][item.dbCloName].toString().replace("0.", ".").length == 3 ? "0":fieldList[idx][item.dbCloName].toString().replace("0.", ".")))))) : (fieldList[idx][item.dbCloName].toString().replace("0.", "."))
                            }
                            onChange={(e) => valSeasonInput(e, item.dbCloName, idx) ? (
                              onChangeHandler(
                                e,
                                item.dbCloName,
                                item.minimum,
                                item.maximum,
                                idx
                              )
                            )
                              :
                              console.log("invlid number")
                            }
                            disabled={!editEnable || item.disabled == "true"}
                            type={
                              item.dataType == "numeric" ? "number" : "text"
                            }
                          />
                        </td>
                      );
                    })}
                  </tr>
                </tbody>
              </table>
            </div>
          );
        })
        : ""}

      {editEnable ? (
        <SaveCancelBtn
          onCancel={onCancelHandler}
          onSave={onSaveHandler}
          id={props.id}
          isEdit={editEnable}
          onEdit={editHandler}
        />
      ) : (
        <AddEditBtn
          id={props.id}
          onEdit={editHandler}
          onAddSeason={addSeasonHandler}
        />
      )}
      <Dialog open={showAddSeasonModal}
              onClose={(event, reason)=> {
                if (reason == "backdropClick" || reason == "escapeKeyDown") {
                  addSeasonHandler(event)
                }
              }}
              className="matDialogCustom"
      >
        <AddSeasonModal
          onClose={addSeasonHandler}
          team={props.team}
          position={props.position}
          id={props.id}
          onSave={createOtherSeason}
        />
      </Dialog>
    </div>
  );
};

export default SeasonsList;
